<template>
  <CCol sm="12">
    <CCard>
      <CCardBody class="p-4">
        <CRow class="justify-content-between align-items-center mb-3">
          <CCol>
            <div class="d-flex align-items-center">
              <figure
                v-if="marketHaveLogo(market)"
                class="m-0 mr-3"
                @click.prevent="openMarket(market)"
              >
                <img
                  :src="marketLogoThumb(market)"
                  alt=""
                  class="border rounded-circle"
                  width="64"
                  height="64"
                />
              </figure>
              <div>
                <div
                  class="
                    d-flex
                    flex-column flex-md-row
                    align-items-start align-items-md-center
                  "
                >
                  <span class="d-inline-block ui-type-display-lg mr-3">
                    <a href="" @click.prevent="openMarket(market)">{{
                      marketName(market)
                    }}</a>
                  </span>
                </div>
                <div v-html="market.market.role.desc_short"></div>
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow class="bg-gray-100 rounded pt-3 px-1 mx-0 text-dark">
          <CCol sm="12" md="4" class="mb-3">
            <div class="ui-type-caption text-uppercase mb-2 border-bottom">
              {{ $t("family.market.box.marketEventsClosure") }}
            </div>
            <div class="">
              <span class="mr-1"
                >{{ $t("family.market.showcase.time_limit") }}
                <strong>{{
                  timelimitToOrder(market, $i18n.locale)
                }}</strong></span
              >
            </div>
            <div>
              <span
                class="badge badge-success mr-2 mt-1"
                v-if="showDelivery(market)"
              >
                <font-awesome-icon icon="truck" />
                {{ $t("family.market.box.delivery") }}</span
              >
              <span class="badge badge-light mt-1" v-if="showPickup(market)">
                <font-awesome-icon icon="store" />
                {{ $t("family.market.box.pickup") }}</span
              >
            </div>
          </CCol>
          <CCol sm="12" md="4" class="mb-3">
            <div class="ui-type-caption text-uppercase mb-2 border-bottom">
              {{ $t("family.market.cart.tot_items") }}
            </div>
            <div class="ui-type-display-sm text-uppercase">
              {{ market.cart.view.n_items }}
            </div>
          </CCol>
          <CCol sm="12" md="4" class="mb-3">
            <div class="ui-type-caption text-uppercase mb-2 border-bottom">
              {{ $t("family.market.cart.tot_order") }}
            </div>
            <div class="ui-type-display-sm text-uppercase">
              {{ cartTotal() }}
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="text-right" v-if="!showProducts">
            <CButton
              class="mt-3"
              color="primary"
              @click="showProducts = true"
              >{{ $t("family.market.cart.show_cart") }}</CButton
            >
          </CCol>
        </CRow>

        <div>
          <MarketCartTable
            v-if="showProducts"
            :market="market"
            @cartUpdated="onCartUpdated"
          />
        </div>
      </CCardBody>
    </CCard>
  </CCol>
</template>

<script>
import { mapGetters } from "vuex";
import { formatPrice } from "../../../helpers/common";
import marketMixin from "../../../mixins/market";
import MarketCartTable from "./MarketCartTable";

export default {
  name: "MarketCart",

  mixins: [marketMixin],

  components: {
    MarketCartTable,
  },

  props: {
    market: { type: Object, required: true },
    loadProducts: { type: Boolean, default: false },
  },

  data() {
    return {
      showProducts: false,
    };
  },

  computed: {
    ...mapGetters("connections", ["currencySymbol", "familyId"]),
  },

  methods: {
    cartTotal() {
      if (this.market.cart) {
        return formatPrice(
          this.market.cart.view.tot,
          this.currencySymbol
        ).format();
      }
      return "";
    },

    onCartUpdated(updatedCart) {
      if (updatedCart) {
        this.market.cart = updatedCart;
      }
    },

    openMarket(market) {
      this.$store.commit("shop/setMarket", market);
      this.$store.commit("shop/setCart", {});
      this.$router.push({
        name: "UserMarketDetail",
        params: { familyId: this.familyId, marketId: market.market.id },
      });
    },
  },

  mounted() {
    if (this.loadProducts) {
      this.showProducts = true;
    }
  },
};
</script>
